import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { DateTimeService } from 'i2g-ng-utils';
import { ISelectOption } from '../select-field/select-field.interface';

@Injectable()
export class TimePickerFieldBuilder {
  constructor(private _dateTimeService: DateTimeService) {}

  buildValues(
    minDateTime: string,
    maxDateTime: string,
    secondsIncrement: number,
    format: string
  ): List<ISelectOption> {
    const range: string[] = this._dateTimeService.getTimeRange(
      minDateTime,
      maxDateTime,
      secondsIncrement
    );
    const values: ISelectOption[] = range.map((value: string) =>
      this.buildValue(value, format)
    );

    return List(values);
  }

  buildValue(value: string, format: string): ISelectOption {
    return {
      key: this._dateTimeService.formatDate(value, format),
      value: value,
    };
  }
}
